export const readCookie = (cookieName) => {
  const cookies = {};
  document.cookie
    .split(';')
    .map((pair) => pair.trim().split('='))
    .forEach((cookieTuple) => {
      const [name, value] = cookieTuple;
      cookies[name] = value;
    });

  return cookies[cookieName] || '';
};
